import * as actionTypes from './actionTypes'
import { roleService } from '../../service'
import { authorizationHelper } from '../../common/helpers/index'
import { httpStatus } from '../../common/constants'

export function getRoles() {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.FETCH_ROLES })

            const response = await roleService.getAll()
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_ROLES_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_ROLES_SUCCESS,
                payload: { roles: data.data, total: 0 }
            })

        } catch (error) {
            if (authorizationHelper.isUnauthorizedCall(dispatch, error.response)) return;
            // TODO: usar un errorHelper para validar estados http
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/role/actions.js